import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AppCrashFallback } from './components/AppCrashFallback';
import { StudioProviders } from './components/StudioProviders';
import { initPostHog } from './lib/posthog';
import { Sentry, initSentry } from './lib/sentry';
import './styles.css';

// Initialize observability + analytics before any React tree renders so a
// render-time error in App still gets captured and pageviews from the very
// first paint are tracked. Both are no-ops when their env keys are absent.
initSentry();
initPostHog();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

const apiBaseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:8080';
const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!clerkPublishableKey) {
  throw new Error('VITE_CLERK_PUBLISHABLE_KEY is required (see .env.example)');
}

createRoot(rootEl).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<AppCrashFallback />}>
      <StudioProviders apiBaseUrl={apiBaseUrl} clerkPublishableKey={clerkPublishableKey}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StudioProviders>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
